import { combineReducers } from 'redux'

import auth from './auth'
import sidebar from './sidebar'
import profile from './profile'
import grades from './grades'
import levels from './levels'
import academicYears from './academicYears'
import importStudents from './importStudents'
import studentsList from './studentsList'
import schoolsList from './schoolsList'
import teachersList from './teachersList'
import supervisorsList from './supervisorsList'
import appsList from './appsList'
import student from './student'
import school from './school'
import messages from './messages'
import supervisor from './supervisor'
import cities from './cities'
import contacts from './contacts'
import states from './states'
import eventsList from './events'
import myEventsList from './myEventsList'
import courseTopics from './courseTopics'
import coursesList from './coursesList'
import myCoursesList from './myCoursesList'
import courseContentsList from './courseContentsList'
import boughtCoursesList from './boughtCourses'
import orders from './orders'
import userBalance from './userBalance'
import stats from './stats'
import questions from './questions'
import onlineTests from './onlineTests'
import myOnlineTestsList from './myOnlineTestsList'
import testToTake from './testToTake'
import answersStash from './answersStash'
import testResult from './testResult'
import questionStash from './questionStash'
import testMakerQuestionsCache from './testMakerQuestionsCache'
import userCertificates from './userCertificates'
import schoolTypes from './schoolTypes'
import educationalLevels from './educationalLevels'
import featuredItems from './featuredItems'
import eventCategories from './eventCategories'
import eventTemplates from './eventTemplates'
import paymentMethods from './paymentMethods'
import supportTickets from './support'
import * as supervisorReducers from './supervisorReducers'

// vendor reducers
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import { responsiveStateReducer } from 'redux-responsive'

//default state
import { defaultState } from '../store/defaultState'

const appReducer = combineReducers({
  browser: responsiveStateReducer,
  routing: routerReducer,
  form: formReducer,
  sidebar,
  profile,
  grades,
  levels,
  auth,
  academicYears,
  importStudents,
  studentsList,
  schoolsList,
  teachersList,
  supervisorsList,
  appsList,
  student,
  messages,
  school,
  supervisor,
  cities,
  contacts,
  states,
  eventsList,
  courseTopics,
  myEventsList,
  coursesList,
  myCoursesList,
  courseContentsList,
  boughtCoursesList,
  orders,
  userBalance,
  userStats: stats,
  questions,
  onlineTests,
  myOnlineTestsList,
  testToTake,
  answersStash,
  testResult,
  questionStash,
  testMakerQuestionsCache,
  userCertificates,
  schoolTypes,
  educationalLevels,
  featuredItems,
  eventCategories,
  eventTemplates,
  paymentMethods,
  supportTickets,
  supervisorReducers: combineReducers(supervisorReducers),
})

// root reducer will act as a proxy for logout or login_as actions
const rootReducer = (state, action) => {
  switch (action.type) {
    case 'LOGOUT_SUCCESS':
      return Object.assign({}, defaultState, { routing: state.routing }) //preserve routing

    case 'LOGIN_AS_SUCCESS':
      // manager must first view the user profile,
      // so the profile info already exists in the store
      return {
        ...defaultState,
        routing: state.routing, //preserve routing
        profile: state.profile, // preserve profile.
        browser: state.browser, // preserve browser.
        auth: action.auth, //set the new auth {userType, token, userId}
      }

    default:
      // delegate
      return appReducer(state, action)
  }
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js